/*!

=========================================================
*　テンプレート
=========================================================
*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  // CardSubtitle,
  Table,
  Row,
  Col,
  // CarouselCaption
} from "reactstrap";

import _ from 'underscore';

import { Link } from 'react-router-dom';
import Images from '../ViewParts/Images';

import Format from '../../common/Format';
import GoogleMap from '../ViewParts/GoogleMap'
import Request from '../../common/Request';
import SystemInfo from '../ViewParts/SystemInfo';
import CustomTd from '../ViewParts/CustomTd';

import WithRole from '../FormParts/ButtonWithRole';

const domain = "";

class Detail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title:"駐車場マスタ情報詳細",
      data: {
        values:{},
      },
    };

    var url = '/api/parking/' + this.props.match.params.ulid;
    let params = {
    };

    Request.get(url, params,
      res => {
        this.setState({
          data: {
            ...this.state.data,
            values:{
              ...res.Data,
              parking_pictures: res.data.parking_picture_filelist?res.data.parking_picture_filelist.split(','):[]
            }
          }
        });
        var url = domain + '/api/landmark/lastupdate/' + res.Data.lastupdate_user_id;
        var params = {};
        Request.get(url, params, res => {
          this.setState({
            data:{
              ...this.state.data,
              values:{
                ...this.state.data.values,
                lastupdate_user:res.Data
              }
            }
          });
        });
  
      })
  }

  componentDidMount() {

  }

  render() {
    const ButtonWithRole = WithRole(Button, this.props.buttons, this.state.data.values)
    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader className="clearfix">
                  <CardTitle tag="h3" className="float-left">{this.state.title}</CardTitle>
                  <ButtonWithRole button_id="BTN_M3_03_04620" className="float-right" onClick={() => { this.props.history.push('/parking/update/' + this.props.match.params.ulid) }}>
                    編集
                  </ButtonWithRole>
                </CardHeader>
                <CardBody className="detail">
                  <SystemInfo
                    id_title='駐車場ID'
                    id_value={this.state.data.values.parking_natural_id}
                    update_timestamp={this.state.data.values.update_timestamp}
                    update_user={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.name}
                    update_user_picture={this.state.data.values.lastupdate_user && this.state.data.values.lastupdate_user.picture} />

                  <CardTitle tag="h4">管理情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th>管理情報</th> */}
                        <CustomTd label='メモ'
                          name='PARKING__system_memo'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='削除フラグ'
                          name='PARKING__delete_flag'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='出入禁止フラグ'
                          name='PARKING__banned_flag'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                    </tbody>
                  </Table>
                  <br />
                  <CardTitle tag="h4">基本情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="3">基本情報</th> */}
                        <CustomTd label='駐車場名'
                          name='PARKING__parking_name'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='駐車場名（カナ）'
                          name='PARKING__parking_name_kana'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      {/* <tr>
                        <CustomTd label='駐車場名（正式名称）'
                          name='PARKING__parking_name_contract'
                          copy={false}
                          data={this.state.data.values} />
                      </tr> */}
                      <tr>
                        {/* <th rowSpan="4">所在地</th> */}
                        <CustomTd label='都道府県'
                          name='PARKING__parking_prefecture'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='市区町村'
                          name='PARKING__parking_city'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='番地（町名以降）'
                          name='PARKING__parking_address'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='土地の地番（契約書記載の所在地）'
                          name='PARKING__parking_address_contract'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        {/* <th rowSpan="6">収容可能車種</th> */}
                        <CustomTd label='ワゴン車'
                          name='PARKING__capacity_flag_car'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='軽トラック'
                          name='PARKING__capacity_flag_light_truck'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='2tトラック'
                          name='PARKING__capacity_flag_truck'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='その他'
                          name='PARKING__capacity_flag_other'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='その他詳細'
                          name='PARKING__capacity_car_type'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='特別条件'
                          name='PARKING__capacity_special_request'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      {/* <tr>
                        <th>特記事項</th>
                        <CustomTd label='特記事項'
                          name='PARKING__special_note'
                          copy={false}
                          data={this.state.data.values} />
                      </tr> */}
                    </tbody>
                  </Table>
                  <br />
                  <CardTitle tag="h4">仕入情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="5">仕入</th> */}
                        <CustomTd label='賃料（月単価）'
                          name='PARKING__cost_parking_rent'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='手数料'
                          name='PARKING__cost_commission'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='敷金'
                          name='PARKING__cost_security_deposit'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='礼金'
                          name='PARKING__cost_key_money'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      {/* <tr>
                        <td className="subTitle">調整額（単価）</td>
                        <td>{Format.comma_delimited(this.state.data.cost_adjustment, '円')}</td>
                      </tr> */}
                      <tr>
                        {/* <th rowSpan="3">計算方法</th> */}
                        <CustomTd label='日割可否'
                          name='PARKING__pay_unit_type_day'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='通し可否'
                          name='PARKING__pay_unit_type_month'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='手数料計算方法'
                          name='PARKING__commission_type'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                    </tbody>
                  </Table>
                  <br />
                  <CardTitle tag="h4">駐車場の特徴</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="2">目印設置</th> */}
                        <CustomTd label='目印設置可否'
                          name='PARKING__landmark_available'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      {/* <tr>
                        <td className="subTitle">敷地内か否か</td>
                        <td>{Common.getValueFormDictArray(parking_onsite_type, this.state.data.parking_onsite_type)}</td>
                      </tr> */}
                      {/* <tr>
                        <td className="subTitle">草が生えているか</td>
                        <td>{Common.getValueFormDictArray(parking_grass_type, this.state.data.parking_grass_type)}</td>
                      </tr> */}
                      <tr>
                        <CustomTd label='駐車方法'
                          name='PARKING__parking_parallel_type'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        {/* <th rowSpan="2">絞込条件</th> */}
                        <CustomTd label='積替用地としての利用実績'
                          name='PARKING__transshipment_flag'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <CustomTd label='単日での利用可否'
                          name='PARKING__oneday_flag'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                    </tbody>
                  </Table>
                  <br />
                  <CardTitle tag="h4">写真・地図</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="3">写真・地図</th> */}
                        <td className="subTitle">写真</td>
                        <td colSpan="3">
                          <Images 
                            image_items={this.state.data.values && (this.state.data.values.parking_pictures || [])} />
                        </td>
                      </tr>
                      <tr>
                        <CustomTd label='緯度'
                          name='PARKING__latitude'
                          copy={false}
                          data={this.state.data.values} />
                        <CustomTd label='経度'
                          name='PARKING__longitude'
                          copy={false}
                          data={this.state.data.values} />
                      </tr>
                      <tr>
                        <td className="subTitle">地図</td>
                        <td colSpan="3">
                          <GoogleMap
                            center={{
                              latitude: this.state.data.values.latitude,
                              longitude: this.state.data.values.longitude
                            }}
                            aerial={false}
                            center_pin={1}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <br />
                  {/* <CardTitle tag="h4">契約情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        <th>契約情報</th>
                        <td className="subTitle">契約書作成</td>
                        <td>{Common.getValueFormDictArray(contract_create_type, this.state.data.contract_create_type)}</td>
                        <td className="subTitle">契約締結</td>
                        <td>{Common.getValueFormDictArray(contract_visit_type, this.state.data.contract_visit_type)}</td>
                      </tr>
                    </tbody>
                  </Table>
                  <br /> */}
                  <CardTitle tag="h4">仕入先情報</CardTitle>
                  <Table>
                    <tbody>
                      <tr>
                        {/* <th rowSpan="4">仕入先情報</th> */}
                        <td className="subTitle">仕入先ID</td>
                        <td>
                          {
                            this.state.data.values &&
                            <Link className="link" target="_blank" to={"/supplier/detail/" + this.state.data.values.supplier_ulid}>{this.state.data.values.supplier_natural_id}</Link>
                          }
                        </td>
                      </tr>
                      <tr>
                        <td className="subTitle">仕入先名</td>
                        <td>{this.state.data.values && this.state.data.values.supplier_name}</td>
                      </tr>
                      <tr>
                        <td className="subTitle">仕入先名（カナ）</td>
                        <td>{this.state.data.values && this.state.data.values.supplier_name_kana}</td>
                      </tr>
                      <tr>
                        <td className="subTitle">電話番号1</td>
                        <td>{this.state.data.values && Format.phone_number(this.state.data.values.supplier_tel)}</td>
                      </tr>
                      <tr>
                        <td className="subTitle">電話番号2</td>
                        <td>{this.state.data.values && Format.phone_number(this.state.data.values.supplier_tel2)}</td>
                      </tr>
                    </tbody>
                  </Table>

                  <Button onClick={() => { this.props.history.push('/parking') }}>一覧に戻る</Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default Detail;
